import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const fileManagerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDirectories: builder.query<any, void>({
      query: () => ({
        url: `/api/media/directories`,
      }),
    }),
    getFilesFromDirectories: builder.mutation<
      any,
      { data: PaginateQuery; directory: string }
    >({
      query: ({ data, directory }) => ({
        url: buildPaginationQueryString(data, `/api/media/files`),
        method: "POST",
        body: { directory },
      }),
    }),
  }),
});

export const { useGetDirectoriesQuery, useGetFilesFromDirectoriesMutation } =
  fileManagerApi;
